var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.2 35.98C322.2 34.3 317.8 34.3 313.8 35.98L51.58 146.4C39.72 151.4 32 162.1 32 175.9V496C32 504.8 24.84 512 16 512C7.164 512 0 504.8 0 496V175.9C0 150.1 15.43 126.9 39.16 116.9L301.4 6.484C313.3 1.469 326.7 1.469 338.6 6.484L600.8 116.9C624.6 126.9 640 150.1 640 175.9V496C640 504.8 632.8 512 624 512C615.2 512 608 504.8 608 496V175.9C608 162.1 600.3 151.4 588.4 146.4L326.2 35.98zM96 224C96 206.3 110.3 192 128 192H512C529.7 192 544 206.3 544 224V496C544 504.8 536.8 512 528 512C527.9 512 527.8 512 527.8 512H112.2C112.2 512 112.1 512 112 512C103.2 512 96 504.8 96 496L96 224zM128 480H512V416H128V480zM128 319.1V384H512V319.1H128zM128 287.1H512V224H128V287.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.5dd0dc3a28fe524a8664361c09f4992f.svg";
export { ForwardRef as ReactComponent };